import { logError } from './utils/logError';
import { showMessage } from './utils/showMessage';
import { loadGrecaptcha } from './async/loadGrecaptcha.js';

const recaptchaV3PublicKey = '6LcSRJQUAAAAAOBCnbGJqpcMO6eEJkaU-R8Ptdjf';

export function getRecaptchaV3PublicKey() {
    return recaptchaV3PublicKey;
}

// Returns the used Captcha type
export function getCurrentCaptchaType() {
    return $('.js-captcha').data('captchaType');
}

// Loads and includes Captcha into html
export function insertCaptcha(captchaType) {
    const captchaContainers = [...document.querySelectorAll('.js-captcha-container')];
    if (captchaContainers.length === 0) return;

    const captchaUrl = captchaType === 'bitrix'
        ? '/include/captcha_bitrix.php'
        : '/include/captcha_google.php';

    fetch(captchaUrl)
        .then(response => response.text())
        .then(html => {
            for (const captchaContainer of captchaContainers) {
                captchaContainer.innerHTML = html;

                if (captchaType === 'google') {
                    loadGrecaptcha()
                        .then(() => {
                            const captcha = captchaContainer.querySelector('[data-captcha-type="google"]');
                            if (!captcha)
                                throw new Error('Не удалось загрузить grecaptcha');

                            grecaptcha.ready(() => {
                                grecaptcha.render(captcha.id, { sitekey: captcha.dataset.siteKey })
                            });
                        })
                        .catch(error => {
                            logError('Не удалось загрузить grecaptcha');
                            showMessage('Ошибка сети, попробуйте обновить страницу');
                        });
                }
            }
        })
        .catch(error => {
            logError(error);
            showMessage('Ошибка сети, обновите страницу');
        });
}

// Reloads the used Captcha
export function reloadCaptcha(usedCaptchaType) {
    if (usedCaptchaType === 'bitrix') {
        $('.js-captcha-word').val('');
        fetch('/authentication/reload_bitrix_captcha.php', {
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
            .then(response => response.json())
            .then(captchaSid => {
                $('.js-captcha-image').attr('src', '/bitrix/tools/captcha.php?captcha_sid=' + captchaSid);
                $('.js-captcha-sid').val(captchaSid);
            })
            .catch(logError);
    } else if (usedCaptchaType === 'google') {
        // Ensure grecaptcah is loaded
        loadGrecaptcha()
            .then(() => {
                grecaptcha.ready(() => {
                    grecaptcha.reset();
                });
            })
            .catch(error => {
                logError('Не удалось загрузить grecaptcha');
                showMessage('Ошибка сети, попробуйте обновить страницу');
            });
    }
}